class FetchOrganizationLogo {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchOrganizationLogo;
